import { ensureMusic, setSoundEnabled, unlockAudio, useSoundEnabled } from '@/audio/rushAudio';
import './MuteButton.css';

export function MuteButton({ className }: { className?: string }) {
  const soundOn = useSoundEnabled();
  return (
    <button
      type="button"
      className={className || 'game-mute-button'}
      aria-pressed={!soundOn}
      onClick={() => {
        const next = !soundOn;
        setSoundEnabled(next);
        if (next) {
          unlockAudio();
          ensureMusic();
        }
      }}
    >
      {soundOn ? 'Mute' : 'Unmute'}
    </button>
  );
}
